import { Theme, lighten, alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { styled } from '@mui/material/styles';
import MuiTableCell from '@mui/material/TableCell';
import { showToast } from '../../../../lib/toast';

export const successToastMessage = (message: string) => {
  showToast({
    type: 'success',
    title: message,
  });
};

export const TableCell = styled(MuiTableCell)({
  borderBottom: 'none',
  whiteSpace: 'nowrap',
});

export const useToolbarStyles = makeStyles()((theme: Theme) => ({
  button: {
    margin: theme.spacing(1),
    width: 200,
  },
  smalltextbox: {
    width: 120,
  },
  longtextbox: {
    width: 700,
  },
  medtextbox: {
    width: 400,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight: {
    paddingRight: 10,
    color: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: lighten(theme.palette.common.black, 0.95),
    height: 35,
  },
  spacer: {
    flex: '1 1 100%',
  },
  title: {
    flex: '0 0 auto',
  },
  searchOption: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.black, 0.1),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.black, 0.05),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
    marginRight: 30,
  },
  IconSearch: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  RootInput: {
    color: 'inherit',
  },
  DialogContent: {
    overflow: 'hidden',
  },
  DataGridCell: {
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
    },
  },
  typo: {
    padding: '10px',
    fontSize: 12,
  },
  SmallButton: {
    margin: theme.spacing(1),
  },
  input: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 120,
      '&:focus': {
        width: 200,
      },
    },
  },
}));
